import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/_services/login.service';
import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl, AbstractControl } from '@angular/forms';
import { GlobalService } from '../_services/global.service';
import { GoogleLoginService } from '../_services/google-login.service';
import { environment } from 'src/environments/environment';
import { TransactionService } from '../_services/transaction.service';
import { SubscriptionLike } from 'rxjs';
import { PersonSearchService } from '../_services/person-search.service';
declare const clevertap;
declare var ga
declare var dataLayer;

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit, OnDestroy {
  candidate_form: FormGroup;
  loginform: FormGroup;
  basicdetails: any;
  signupform: boolean;
  confirmemailform: boolean = false
  login_form: boolean = false;
  termsacceptError: boolean = false;
  loginError: boolean;
  alreadyExist: boolean;
  verifyMessage: string;
  successMessage: any;
  errorMessage: any;
  referredvia: string;
  verifyEmailStatus: number; // 2 : Email not verified , 3 : email Sent but didn't receive
  federatedLoginEmailNotRegistered: boolean = false;
  redirectedFromCompanypages: boolean = false;
  companypagesInfo: any;
  emailFromCompanyPages: any;
  isMobile: boolean = false;

  @ViewChild('googleSignUpButton') googleSignUpButton: ElementRef<HTMLInputElement>;
  @ViewChild('googleLoginButton') googleLoginButton: ElementRef<HTMLInputElement>;
  googleUser: any;
  registeredVia: string;
  subscriptiondetails: any = {};
  isteamMember: boolean;
  teamadminemailid: any;
  googlejwttoken:any;
  googleDataCredsSubscription: SubscriptionLike;
  show: any
  geoIpLocationData: { country: string, city: string, region: string, continent: string } = {
    country: 'India',
    city: 'Mumbai',
    region: 'Maharashtra',
    continent: 'Asia'
  }

  constructor(public fb: FormBuilder, private loginservice: LoginService, private router: Router, private route: ActivatedRoute,
    private localstorageservice: LocalStorageService,
    private googleLoginService: GoogleLoginService, private transactionservice: TransactionService, private personSearchService: PersonSearchService) {
  }



  ngOnInit() {
    if(window.innerWidth <= 425 ){
      this.isMobile = true;
    } else{
      this.isMobile = false;
    }
    this.companypagesInfo = {
      companyid: this.route.snapshot.queryParamMap.get('companyid'),
      companyname: this.route.snapshot.queryParamMap.get('companyname'),
      industry: this.route.snapshot.queryParamMap.get('industry')
    }

    if(this.companypagesInfo && this.companypagesInfo.companyid ){
      this.redirectedFromCompanypages = true;
    }
    if(this.localstorageservice.getItem('userid')){
      if(!this.redirectedFromCompanypages && this.router.url.includes('teaminvite')){
        this.route.queryParams.subscribe(params => {
          this.teamadminemailid = GlobalService.decryptData(params['tokense']);
          if (this.teamadminemailid) {
            localStorage.setItem('teaminviteurl', environment.frontendurl + this.router.url)
          }
        });
        let url = localStorage.getItem('teaminviteurl').split('?redirect=')[1].replace(/%2F/g, "/").replace('teaminvite&','teaminvite?');
        this.router.navigateByUrl(url);
      }else if(!this.redirectedFromCompanypages){
        // handle route redirection
        if(this.router.url.includes('?redirect=')) {
          const urlToRedirectTo = decodeURIComponent(this.router.url.split('?redirect=')[1]);
          urlToRedirectTo && this.router.navigateByUrl(urlToRedirectTo);
        } else this.router.navigateByUrl('/person/search')
      } else{
        this.router.navigateByUrl(`/company-directory/${this.companypagesInfo.companyname}/${this.companypagesInfo.companyid}?industry=${this.companypagesInfo.industry}`)
      }
    }else if(this.router.url.includes('teaminvite')){
      this.router.navigateByUrl('/login')
    }

    if (this.router.url.includes('login')) {
      this.openLoginForm()
    } else {
      this.signupform = true
    }

    this.route.queryParams.subscribe(params => {
      this.teamadminemailid = GlobalService.decryptData(params['tokense']);
      if (this.teamadminemailid) {
        localStorage.setItem('teaminviteurl', environment.frontendurl + this.router.url)
      }
    });

    this.referredvia = this.route.snapshot.queryParamMap.get('ref');
    this.candidate_form = this.fb.group({
      firstName: ['', Validators.compose([Validators.required, noWhitespaceValidator, Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      lastName: ['', Validators.compose([Validators.required, noWhitespaceValidator, Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      workid: ['', Validators.compose([Validators.required, Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$'), Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      mobileno: ['', Validators.compose([Validators.required, noWhitespaceValidator, Validators.pattern('^[+]?[0-9 ]*$')])],
      designation: ['', Validators.compose([Validators.required, noWhitespaceValidator, Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      password: ['', Validators.required],
      companyname: ['', Validators.compose([Validators.required, noWhitespaceValidator, Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      termsaccept: [''],
      confirmpwd: ['', Validators.required]
    })

    function noWhitespaceValidator(control: AbstractControl) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'required': true };
    }

    this.loginform = this.fb.group({
      emailid: ['', Validators.compose([Validators.required, Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$')])],
      password: ['', Validators.required]
    })


    if (this.router.url.includes('verified')) {
      this.route.queryParamMap.subscribe((res: any) => {
        let activationcode = res.params.verified
        let email = res.params.email;
        if (activationcode && email) {
          if (activationcode === '446080') { // if email verified
            this.toastmessage("Email verified successfully", "success")
            this.loginform.patchValue({ emailid: email });
          } else if (activationcode === '807024') { // if candidate email doesn't exisit
            this.toastmessage("Email doesn't exist", "error")
          } else if (activationcode === '667030') { // verification link expired
            setTimeout(() => {
              this.toastmessage("Verification link expired", "error")
              // const modalRef = this.modalService.open(this.verifyModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false })
            }, 200);
          } else if (activationcode === '307730') { // some other error
            this.verifyMessage = 'Something went wrong. Please try again later';
          }
        }
      })
    }

    if (this.signupform || this.login_form) {
      this.federatedLinkedInLogin();
      setTimeout(() => {
        if (this.signupform) {
          this.googleLoginService.initGoogleSignIn(this.googleSignUpButton.nativeElement,this.signupform);
        } else {
          this.googleLoginService.initGoogleSignIn(this.googleLoginButton.nativeElement,this.signupform);
        }
      }, 100);
    }
    this.googleDataCredsSubscription = this.googleLoginService.credentialDataObservable.subscribe((data)=>{
      this.googlejwttoken=data;      
      this.logincandidate(true, null, 'google')
    })

    this.emailFromCompanyPages = this.route.snapshot.queryParamMap.get('email')
    if( this.redirectedFromCompanypages && this.emailFromCompanyPages && this.emailFromCompanyPages.length>0 && this.emailFromCompanyPages.toLowerCase() != 'undefined' ){
      this.candidate_form.patchValue({workid: this.emailFromCompanyPages })
    }
  }
  ngOnDestroy(): void {
    this.googleDataCredsSubscription && this.googleDataCredsSubscription.unsubscribe();   
  }

  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }


  openLoginForm() {
    this.login_form = true;
    this.confirmemailform = false;
    this.signupform = false
  }

  reconfirmpwd() {
    if (this.candidate_form.value.password == this.candidate_form.value.confirmpwd) {
      return this.candidate_form['controls'].confirmpwd.setErrors(null)
    } else {
      return this.candidate_form['controls'].confirmpwd.setErrors({ 'invalidpwd': true })
    }
  }

  candidatesignup() {
    if (this.candidate_form.valid) {
      var isRedirectExtension = false
      if(this.route.snapshot.queryParamMap.get('source') == 'extension'){
        isRedirectExtension = true
      }
      if (this.candidate_form.value.termsaccept == true) {
        this.termsacceptError = false
        let data = {
          firstname: "'" + this.candidate_form.value.firstName + "'",
          lastname: "'" + this.candidate_form.value.lastName + "'",
          loginemail: "'" + this.candidate_form.value.workid + "'",
          pwd: "'" + this.candidate_form.value.password + "'",
          designation: "'" + this.candidate_form.value.designation + "'",
          extn: "'" + this.candidate_form.value.mobileno + "'",
          company: "'" + this.candidate_form.value.companyname + "'",
          registeredvia: isRedirectExtension ? "'Extension'" : "'registration form'"
        }

        if (this.referredvia) {
          data['referredvia'] = "'" + this.referredvia + "'"
        }

        this.loginform.patchValue({ emailid: data.loginemail.replace(/'/g, "") });

        if (this.teamadminemailid) {
          data['teamadminemailid'] = "'" + this.teamadminemailid + "'"
          data['teaminviteurl'] = "'" + environment.frontendurl + this.router.url + "'"
          data['referredvia'] = "'teaminvite'"
        }

        if(this.redirectedFromCompanypages){
          data['referredvia'] = "'companypages'";
          data['companypageinfo'] = this.companypagesInfo;
        }

        this.loginservice.signup(data).subscribe((res: any) => {
          if (res.status == 'success') {
            let clevertap_signup = {
              "Name": this.candidate_form.value.firstName + " " + this.candidate_form.value.lastName,
              "Email": this.candidate_form.value.workid,
              "Phone": "+91" + this.candidate_form.value.mobileno,
              companyname: this.candidate_form.value.companyname,
              designation: this.candidate_form.value.designation,
              registeredvia: isRedirectExtension ? "'Extension'" : "'registration form'"
            }

            clevertap.onUserLogin.push({ "Site": clevertap_signup })
            clevertap.event.push("signup", clevertap_signup);
            this.signupform = false
            this.confirmemailform = true;
            dataLayer.push({'event':'signup','signup': 'true'}); 
            if(this.redirectedFromCompanypages){
              dataLayer.push({'event':'company_pages_signup','company_pages_signup': 'true'});    
            }            
            // ga('send', 'event', 'WebbTreeSignup', 'WebbTreeSignup', 'First Signup');
          }
          else if (res.message == 'Duplicate user') {
            this.alreadyExist = true
          } else {
            console.log("errror")
          }
        })
      } else {
        this.termsacceptError = true
      }
    }
    else {
      this.validateAllFormFields(this.candidate_form);
    }
  }

  logincandidate(federatedLogin?: boolean, emailID?: string, loginwith?: string) {
    if (this.loginform.valid || (federatedLogin && emailID && loginwith !='google') || (federatedLogin && loginwith =='google')) {
      let data = {
        email: "'" + ((federatedLogin) ? emailID : this.loginform.value.emailid) + "'"
      }
      if (federatedLogin) {
        data['loginwith'] = loginwith
        if(loginwith =='google'){
          data['email']=null
          data['googlecredentialjwttoken']=this.googlejwttoken;   
        }
      } else {
        data['password'] = this.loginform.value.password
      }
      
      this.loginservice.login(data).subscribe((res: any) => {               
        if (res.status == 'success') { 
          res.data = JSON.parse(GlobalService.decryptData(res.message))
          let userdata = res.data
          const updateLocation = userdata.updateLocation;
          let usernumber = res.data.usernumber
          let userid = res.data.userid
          let ufname = res.data.firstname
          let ulname = res.data.lastname
          let token = res.data.token
          let firstlogin = res.data.firstlogin
          let emailId=res.data.loginemail;
          this.localstorageservice.setItem('tabName', 'quicksearch');
          this.localstorageservice.setItem('userdata', userdata)
          this.localstorageservice.setItem('stripesubscriptionid',userdata.stripesubscriptionid)
          this.localstorageservice.setItem('stripecustomerid',userdata.stripecustomerid)
          this.localstorageservice.setItem('stripebillingcountry',userdata.stripebillingcountry)
          this.localstorageservice.setItem('usernumber', usernumber)
          this.localstorageservice.setItem('userid', userid)
          this.localstorageservice.setItem('usermailid', (federatedLogin ? emailId : this.loginform.value.emailid))
          this.localstorageservice.setItem('ufname', ufname)
          this.localstorageservice.setItem('ulname', ulname)
          this.localstorageservice.setItem('token', token)
          this.localstorageservice.setItem('role', res.data.role)
          
          if (res.data.teaminviteurl) {
            localStorage.setItem('teaminviteurl', res.data.teaminviteurl)
          }

          this.loginservice.getGeoIpLocationOfUser(updateLocation).subscribe((res: any) => {
            
            if (res.status == 'success' && res.data && !res.data.isEU && !['europe', 'antarctica'].includes(res.data.continent) && res.data.continentCode != 'EU') {
              this.geoIpLocationData.country = res.data.country;
              this.geoIpLocationData.city = res.data.city;
              this.geoIpLocationData.region = res.data.region;
              this.geoIpLocationData.continent = res.data.continent;
            }
            this.personSearchService.setGeoIpLocationOfUser(this.geoIpLocationData);
            this.localstorageservice.setItem('region', this.geoIpLocationData.continent ? this.geoIpLocationData.continent.toLowerCase() : 'asia')
            this.localstorageservice.setItem('userGeoIpLocation', JSON.stringify(this.geoIpLocationData));
            this.localstorageservice.setItem('talentRegion', this.geoIpLocationData.continent ? this.geoIpLocationData.continent.toLowerCase() : 'asia');
          });

          //to send usernumber to chrome extension
          let chromeid = localStorage.getItem('extensionID');
          let isChromeInstalled;          
          if (chromeid) {
            try {
              window['chrome'].runtime.sendMessage(chromeid, { action: 'login', usernumber: usernumber, userid: userid, firstname: ufname, lastname: ulname, token: token, userdata: userdata });
              window['chrome'].runtime.sendMessage(chromeid, { action: 'getSimilarCandidateResult' }, function (res) {
                if (res.similarCandidateData) {
                  isChromeInstalled = true
                }
              });
            } catch (error) {
              isChromeInstalled = false
              console.error('Here is the error message', error);
            }
          }
          this.fetchcredits()
          this.loginservice.isloggedin(usernumber).subscribe((res: any) => {            
            if (res.status == 'success') {
              this.verifyEmailStatus = undefined;
              if (this.router.url.includes('?redirect=') && !this.router.url.includes('teaminvite&')) {
                let url = this.router.url.split('?redirect=')[1].replace(/%2F/g, "/");
                if(this.redirectedFromCompanypages){
                  this.router.navigateByUrl(`/company-directory/${this.companypagesInfo.companyname}/${this.companypagesInfo.companyid}?industry=${this.companypagesInfo.industry}`)
                } else {
                  this.router.navigateByUrl(url);
                }
              } else if (localStorage.getItem('teaminviteurl') && localStorage.getItem('teaminviteurl').includes('teaminvite&')) {
                // let url = localStorage.getItem('teaminviteurl').replace('teaminvite&','teaminvite?')
                let url = localStorage.getItem('teaminviteurl').split('?redirect=')[1].replace(/%2F/g, "/").replace('teaminvite&', 'teaminvite?');
                if(this.redirectedFromCompanypages){
                  this.router.navigateByUrl(`/company-directory/${this.companypagesInfo.companyname}/${this.companypagesInfo.companyid}?industry=${this.companypagesInfo.industry}`)
                } else {
                  this.router.navigateByUrl(url);
                }
                localStorage.removeItem('teaminviteurl')
              } else {
                setTimeout(() => {
                  if (firstlogin == 0 && isChromeInstalled != true) {
                    if(this.redirectedFromCompanypages){
                      this.router.navigateByUrl(`/company-directory/${this.companypagesInfo.companyname}/${this.companypagesInfo.companyid}?industry=${this.companypagesInfo.industry}`)
                    } else {
                      this.router.navigateByUrl('/firstlogin')
                    }
                  } else {
                    if(this.redirectedFromCompanypages){
                      this.router.navigateByUrl(`/company-directory/${this.companypagesInfo.companyname}/${this.companypagesInfo.companyid}?industry=${this.companypagesInfo.industry}`)
                    } else {                      
                      this.router.navigateByUrl('/person/search')
                    }
                  }
                }, 500)
              }

            }

            else {
              this.toastmessage('Something went Wrong', 'error')
            }
          })

          //-Clevertap Register profile
          let phone = userdata.extn ? "+91"+userdata.extn : "";  
          let userprofile = {
            "Name": userdata.firstname + " " + userdata.lastname,
            "Email": userdata.loginemail,
            "Identity": userdata.userid,
            "Phone": phone,
            // "Gender": userdata.gender,
            // "DOB": userdata.dob,
            "usertype": null,
            "Plan": userdata.paymentplanid,
            "Company Name": userdata.company,
            "Designation": userdata.designation,
            "Basic contact enrichment credits": userdata.balancebasiccontactenrichmentcredits,
            "Bulk Grabbing Credits": userdata.balancebulkgrabbingcredits,
            "Contact enrichment credits": userdata.balancecontactenrichmentcredits,
            "JD Parsing Credit": userdata.balancejdparsingcredits,
            "Balance Smart Email Credits": userdata.balancesmartemailcredits,
            "Balance Talent Pipeline Credits": userdata.balancetalentpipelinecredits,
            "Pooled Balance Basic Contact Enrichment Credits": userdata.pooledbalancebasiccontactenrichmentcredits,
            "Pooled Balance Bulk Grabbing Credits": userdata.pooledbalancebulkgrabbingcredits,
            "Pooled Balance Contact Enrichment Credits": userdata.pooledbalancecontactenrichmentcredits,
            "Pooled Balance JD Parsing Credits": userdata.pooledbalancejdparsingcredits,
            "Pooled Balance Smart Email Credits": userdata.pooledbalancesmartemailcredits,
            "Pooled Balance Talent Pipeline Credits": userdata.pooledbalancetalentpipelinecredits,
          }
          clevertap.onUserLogin.push({ "Site": userprofile });

          //-Clevertap Login event
          clevertap.event.push("Login");
          if(this.route.snapshot.queryParamMap.get('source') == 'extension'){
            clevertap.event.push("Login_Extension");
          }

          console.log("Login CT event");
        } else if (res.message == "Email or password is invalid" && federatedLogin) {
          this.registerUserViaFederatedLogin({googlejwttoken:this.googlejwttoken}, 'google');
        }
        else if (res.message == 'Email is not verified') {
          this.verifyEmailStatus = 2
          this.loginError = false
        } else if (federatedLogin) {
          this.federatedLoginEmailNotRegistered = true;
        } else {
          this.loginError = true
          this.verifyEmailStatus = undefined
        }
      })
    }
    else {
      this.validateAllFormFields(this.loginform)
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  resendVerficationLink() {


    if (this.loginform.controls.emailid.valid) {
      let data = {
        loginemail: this.loginform.value.emailid,
      }
      this.loginservice.resendVerificationEmail(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.toastmessage('Email link sent', 'success')
          this.verifyEmailStatus = 3
        } else {
          if (res.message == 'Email already verified') {
            this.toastmessage('Email already verified', 'error')
          } else {
            this.toastmessage('Something went Wrong', 'error')
          }
        }
      })
    } else {
      this.validateAllFormFields(this.loginform)
    }
  }


  registerUserViaFederatedLogin(userDetails: any, type: string) {
    let data = {
      registeredvia: "'" + type + "'"
    }
    if(type!='google'){
      data['firstname']= "'" + userDetails.firstName + "'"
      data['lastname']="'" + userDetails.lastName + "'"
      data['loginemail']="'" + userDetails.email + "'"
    }
    else{
      //add jwt token from google authentication
      data['googlecredentialjwttoken']=userDetails.googlejwttoken;
    }

    if (this.referredvia) {
      data['referredvia'] = "'" + this.referredvia + "'"
    }

    if (this.teamadminemailid) {
      data['teamadminemailid'] = "'" + this.teamadminemailid + "'"
      data['teaminviteurl'] = "'" + environment.frontendurl + this.router.url + "'"
      data['referredvia'] = "'teaminvite'"
    }

    if(this.redirectedFromCompanypages){
      data['referredvia'] = "'companypages'";
    }

    this.loginservice.signup(data).subscribe((res: any) => {
      if (res.status == 'success') {
        dataLayer.push({'event':'signup','signup': 'true'});  
        if(this.redirectedFromCompanypages){
          dataLayer.push({'event':'company_pages_signup','company_pages_signup': 'true'});    
        }
        //ga('send', 'event', 'WebbTreeSignup', 'WebbTreeSignup', 'First Signup');
        if(type=='google'){
          this.logincandidate(true, null, type);
        }
        else{
          this.logincandidate(true, userDetails.email, type);
        }
      } else if (res.message == 'Duplicate user') {
        this.alreadyExist = true;
      }
      else {
        console.log("error");
        this.toastmessage('Something went Wrong', 'error');
      }
    })
  }

  signUpWithLinkedIn() {
    window.location.href = environment.linkedinurlredirect + window.location.origin + '/signup&state=' + window.location.origin + '/signup&scope=r_liteprofile%20r_emailaddress';
  }

  loginWithLinkedIn() {
    window.location.href = environment.linkedinurlredirect + window.location.origin + '/login&state=' + window.location.origin + '/login&scope=r_liteprofile%20r_emailaddress';
  }

  federatedLinkedInLogin() {
    this.route.queryParamMap.subscribe((param: any) => {
      let data = {
        code: param.params.code,
        state: window.location.origin + (this.signupform ? '/signup' : '/login')
      }

      if (data.code) {
        this.loginservice.federatedLinkedInLogin(data)
          .subscribe((res: any) => {
            if (res.status === 'success' && res.message) {
              let userDetails = {
                firstName: res.message.firstname,
                lastName: res.message.lastname,
                email: res.message.personalemail
              };
              if (data.state.includes('/signup')) {
                this.registerUserViaFederatedLogin(userDetails, 'linkedin');
              } else {
                this.loginform.patchValue({ emailid: userDetails.email })
                this.logincandidate(true, userDetails.email, 'linkedin');
              }
              if(this.redirectedFromCompanypages){
                this.router.navigateByUrl(`/company-directory/${this.companypagesInfo.companyname}/${this.companypagesInfo.companyid}?industry=${this.companypagesInfo.industry}`)
              }
            } else {
              this.toastmessage('Something went Wrong', 'error')
            }
          });
      }
    });
  }

  fetchcredits() {
    this.transactionservice.updateAllCreditsForCurrentUser().subscribe((userData: any) => {
      this.subscriptiondetails = { ...this.subscriptiondetails, ...userData };
    });
  }

  redirect() {
    const downloadLink = document.createElement("a");
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.setAttribute("href", 'https://webbtree.freshdesk.com/support/tickets/new');
    downloadLink.setAttribute("target", "_blank");
    downloadLink.click();
  }
}

